<template>
  <div class="seller-settings">
    <div class="settings-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="[tab.tabClass || '', { active: tab.key === activeTabKey }]"
        class="settings-tab"
        @click="activeTabKey = tab.key">
        {{ tab.label }}
      </div>
    </div>
    <component v-if="activeTab" :is="activeTab.component" :class="activeTab.class"></component>
  </div>
</template>
<script setup lang="ts">
  import { computed, markRaw, ref } from "vue";
  import { trans } from "@/utils/trans";
  import { Hotkeys, Interface, Labels } from "@/components/action-block/tabs/seller/settings";

  const activeTabKey = ref("interface");
  const activeTab = computed(() => tabs.value.find(({ key }) => key === activeTabKey.value));

  const tabs = ref([
    {
      label: trans("live.tabs.settings.interface_tab.label"),
      key: "interface",
      component: markRaw(Interface),
      class: "interface-settings"
    },
    {
      label: trans("live.tabs.settings.hotkeys_tab.label"),
      key: "hotkeys",
      component: markRaw(Hotkeys),
      class: "hotkeys-settings stage-b-item",
      tabClass: "stage-b-item",
    },
    {
      label: trans("live.tabs.settings.labels_tab.label"),
      key: "labels",
      component: markRaw(Labels),
      class: "labels-settings"
    }
  ]);
</script>
